import ErrorComponent from "components/shared/ErrorComponent"
import LoadingIndicator from "components/shared/LoadingIndicator"
// import Images from 'constant/Images'
import { Formik } from "formik"
import { convertToMomentDate, getGoalTrackingPercentage, successMessageToast, userFullName } from "helpers/common"
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Col, Container, Form, Row } from 'react-bootstrap'
import { generatePath, Link, useLocation, useNavigate, useParams } from "react-router-dom"

import { GOAL_TRACK_PARAMETERS_STAFF } from "config/constants"
import AppInputField from "components/shared/FormComponents/AppInputField"
import { RequiredFieldAstrick } from "components/Common/Common"
import { taskSubmissionValidation } from "utils/validation/validationHelpers"
import LoadingButton from "components/shared/LoadingButton"
import { cloneDeep, isEmpty } from "lodash"
import { CLIENTS } from "config/paths"
import Switch from "react-switch";
import AppFileUploadField from "components/shared/FormComponents/AppFileUploadField"
import { MIME_TYPES } from "config/constants";
import ConfirmationPop from "components/Modals/ConfirmationPop"
// import AppFileUploadNestedField from "components/shared/FormComponents/AppFileUploadNestedField.jsx"
import GoalTrackingForm from "./Components/GoalTrackingForm"
import { useLazyGetFileUrlQuery } from "store/services/utility"
import { useGetStaffGroupSessionViewQuery } from "store/services/supportStaff"
import SessionOutcomePieChart from "components/ReportComponents/SessionOutcomePieChart"
import TrackerRangeSlider from "components/ReportComponents/TrackerRangeSlider/Index"
import ViewAttachments from "../TaskSessionView/ViewAttachments"
import NotesComponent from "components/shared/FormComponents/NotesComponent"
import moment from "moment"
import { useGetNoteQuery } from "store/services/note"

const GroupTaskSession = () => {
    const { staffId, groupId } = useParams();
    const clientId = ""
    const taskId = ""
    const { state } = useLocation();
    const formikRef = useRef();
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const task_datetime = queryParams.get('task_datetime');

    const [checked, setChecked] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [formValues, setFormValues] = useState(null);

    // save task progress
    //   const [saveProgress, { isLoading: saveProgressLoading }] = useSaveGroupTaskProgressMutation();
    //   const [submitTask, { isLoading: submitTaskLoading }] = useSubmitGroupTaskProgressMutation();

    // get task progress
    const [getFileUrl, { isLoading: getFileLoading, isFetching: getFileFetching }] = useLazyGetFileUrlQuery();
    const { data, isLoading, isError } = useGetStaffGroupSessionViewQuery({ staffId, task_datetime, groupId }, { skip: !task_datetime });
    const { data: noteDetails } = useGetNoteQuery({ clientId: groupId, moduleName: `task_occurence` });
    const therapist = data?.taskDetails?.associatedTasks?.owner;
    const task = data?.taskDetails?.associatedTasks;
    const previewMode = true;
    const trackerType = data?.taskDetails?.associatedTasks?.tracker_type;

    const initialValues = useMemo(() => {
        const output = {
            clientData: data?.AllTaskData?.map((item, index) => {
                const taskData = typeof item?.associatedMapping?.task_data === 'string'
                    ? JSON.parse(item?.associatedMapping?.task_data)
                    : item?.associatedMapping?.task_data || {};

                return {
                    client_id: item?.client_id || null,
                    // attendance: item?.associatedTaskProgress?.attendance || "absent",
                    attendance: item?.associatedMapping?.attendance || "absent",
                    [data?.taskDetails?.associatedTasks?.tracker_type == "discrete" ? 'goalTracking' : 'tracker']:
                        data?.taskDetails?.associatedTasks?.tracker_type == "discrete"
                            ? (!isEmpty(taskData?.goalTracking) ? taskData?.goalTracking : [{}])
                            : (!isEmpty(taskData?.tracker) ? taskData?.tracker : {}),
                    answer: taskData?.answer || "",
                    files: taskData?.files || []
                };
            }),
        };

        // if (trackerType === "discrete") {
        //   output.goalTracking = !isEmpty(taskProgress?.task_data?.goalTracking) ? taskProgress?.task_data?.goalTracking : [{}];
        // } else if (trackerType === "frequency") {
        //   output.tracker = !isEmpty(taskProgress?.task_data?.tracker) ? taskProgress?.task_data?.tracker : {};
        // }

        return output;
    }, [data]);

    const handleViewPdf = async (name) => {

        try {
            const url = await getFileUrl(name).unwrap();
            if (url) window.open(url, '_blank');

        } catch (err) { console.error("Error assigning therapist", err); }
    };


    useEffect(() => {
        try {
            const payload = {
                taskId,
                clientId,
                data: {
                    task_datetime
                }
            }
            getTaskData(payload)
        } catch (err) {
            console.error("Error getting progress data", err);
        }
    }, [state, taskId, clientId]);

    const validationSchema = useMemo(() => {
        // return taskSubmissionValidation()
    }, []);

    const handleSaveProgress = async () => {
        try {
            const values = formikRef?.current?.values;
            if (!values) {
                throw new Error("Form values not found");
            }

            // const payload = {
            //   taskId,
            //   clientId,
            //   data: {
            //     task_data: values,
            //     task_datetime: state?.task_datetime,
            //     attendance: checked ? "present" : "absent"
            //   }
            // }

            const payload = {
                task_datetime: task_datetime,
                clientData: values?.clientData?.map((item, index) => ({
                    attendance: item?.attendance,
                    client_id: item?.client_id,
                    task_data: {
                        [data?.taskDetails?.associatedTasks?.tracker_type == "discrete" ? [`goalTracking`] : [`tracker`]]: data?.taskDetails?.associatedTasks?.tracker_type == "discrete" ? item?.goalTracking : item?.tracker,
                        answer: item?.answer,
                        files: item?.files
                    }
                }))
            }

            // console.log('data of submiited formik', body)

            await saveProgress({ groupId: taskId, payload }).unwrap();
            successMessageToast("Progress saved!");
        } catch (err) {
            console.error("Error saving task progress", err);
        }
    }

    const confirmHandleSubmit = async () => {
        setShowModal(false)
        try {
            // const payload = {
            //   taskId,
            //   clientId,
            //   data: {
            //     // task_data: values,
            //     task_data: formValues,
            //     task_datetime: state?.task_datetime,
            //     attendance: checked ? "present" : "absent"
            //   }
            // }

            const payload = {
                task_datetime: task_datetime,
                clientData: formValues?.clientData?.map((item, index) => ({
                    attendance: item?.attendance,
                    client_id: item?.client_id,
                    task_data: {
                        [data?.taskDetails?.associatedTasks?.tracker_type == "discrete" ? [`goalTracking`] : [`tracker`]]: data?.taskDetails?.associatedTasks?.tracker_type == "discrete" ? item?.goalTracking : item?.tracker,
                        answer: item?.answer,
                        files: item?.files
                    }
                }))
            }


            // console.log("payload------------->",payload)
            // console.log("formValues------------->",formValues)
            await submitTask({ groupId: taskId, payload }).unwrap();
            successMessageToast("Task submitted!");
            navigate(-1);
        } catch (err) {
            console.error("Error submitting task", err);
        }
    }

    const handleSubmit = (values) => {
        console.log('values of form submiited', values)
        setFormValues(values);
        setShowModal(true);
    };

    const handleAttachDocument = (name, value, prevValues, setFieldValue) => {
        try {
            let cloneValues = prevValues ? cloneDeep(prevValues) : [];
            cloneValues.push({
                attachment_key: value,
                attachment_name: value,
            })
            setFieldValue(name, cloneValues);
        } catch (err) {
            console.error("Failed to attach document", err);
        }
    };


    useEffect(() => {
        if (data) {
            setChecked(data?.associatedTaskProgress?.attendance == "present");
        }
    }, [data]);

    return (
        <>
            <ConfirmationPop
                confirmation={showModal}
                setConfirmation={setShowModal}
                type={"tasksumbit"}
                confirmHandler={confirmHandleSubmit}
            />
            <section className='mt-3 border-bottom'>
                <Container fluid>
                    <Row className='justify-content-between align-items-center'>
                        <Col lg='6'>
                            <p className='mb-0'>
                                <Link
                                    to={-1}
                                    className="themeClr"
                                >
                                    Clients
                                </Link>
                                {" "}/{" "}
                                <span className='mb-0' style={{ fontWeight: "600" }}>Start Session</span></p>
                        </Col>
                        {/* <Col lg='6' className='d-flex justify-content-end'>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                <label class="form-check-label" for="flexCheckDefault" style={{ fontSize: "14px" }}>
                  Mark as Completed
                </label>
              </div>
            </Col> */}
                    </Row>
                </Container>
            </section>

            {isLoading ? (
                <LoadingIndicator />
            ) : isError ? (
                <ErrorComponent />
            ) : (
                <section>
                    <section className='mt-4'>
                        <Container fluid>
                            <Row>
                                <Col lg='6'>
                                    <Row>
                                        <Col md="6" sm="6" className='my-2'>
                                            <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                                <h6 class="m-0 themeBlue fw-bold">
                                                    <span class="" style={{ color: 'rgb(61, 160, 170)' }}>
                                                        ■</span>{" "}
                                                    Task Title
                                                </h6>
                                                <p class="m-0 themeBlue pt-2">
                                                    {data?.taskDetails?.associatedTasks?.task_title}
                                                </p>
                                            </div>
                                        </Col>
                                        <Col md="6" sm="6" className='my-2'>
                                            <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                                <h6 class="m-0 themeBlue fw-bold">
                                                    <span class="" style={{ color: 'rgb(61, 160, 170)' }}>
                                                        ■</span>{" "}
                                                    Group Name
                                                </h6>
                                                <p class="m-0 themeBlue pt-2">
                                                    {data?.taskDetails?.associatedTasks?.group_name}
                                                </p>
                                            </div>
                                        </Col>
                                        <Col md="6" sm="6" className='my-2'>
                                            <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                                <h6 class="m-0 themeBlue fw-bold">
                                                    <span class="" style={{ color: 'rgb(61, 160, 170)' }}>
                                                        ■</span>{" "}
                                                    Name of Discipline
                                                </h6>
                                                <p class="m-0 themeBlue pt-2">
                                                    {therapist?.therapist_detail?.therapist_discipline?.name}
                                                </p>
                                            </div>
                                        </Col>
                                        {/* <Col md="6" sm="6" className='my-2'>
                      <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                        <h6 class="m-0 themeBlue fw-bold">
                          <span class="" style={{ color: 'rgb(61, 160, 170)' }}>
                            ■</span>{" "}
                          Category
                        </h6><p class="m-0 themeBlue pt-2">{clientdetails?.client_type}
                        </p>
                      </div>
                    </Col> */}
                                        <Col md="6" sm="6" className='my-2'>
                                            <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                                <h6 class="m-0 themeBlue fw-bold">
                                                    <span class="" style={{ color: 'rgb(61, 160, 170)' }}>
                                                        ■</span>{" "}
                                                    Clinician
                                                </h6><p class="m-0 themeBlue pt-2">{userFullName(therapist)}</p>
                                            </div>
                                        </Col>
                                        {/* <Col md="6" sm="6" className='my-2'>
                      <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                        <h6 class="m-0 themeBlue fw-bold">
                          <span class="" style={{ color: 'rgb(61, 160, 170)' }}>
                            ■</span>{" "}
                          Attendance
                        </h6>
                        <div className="mt-2 d-flex align-items-center">
                          <span>Absent</span>
                          <Switch
                            className="mx-2"
                            uncheckedIcon={""}
                            checkedIcon={""}
                            onHandleColor={"#A3DF00"}
                            offHandleColor={"#A3DF00"}
                            onColor={"#E6E6E6"}
                            offColor={"#E6E6E6"}
                            height={18}
                            width={40}
                            checked={checked}
                            onChange={(checked) => setChecked(checked)}
                            disabled={previewMode}
                          />
                          <span>Present</span>
                        </div>
                      </div>
                    </Col> */}
                                    </Row>
                                </Col>
                                <Col lg='6'>
                                    <Row className='justify-content-end pe-2 align-items-start'>
                                        <Col lg="4" className='my-2'>
                                            <div className="cardCstm p-3 bg-white shadow h-100 rounded border-bottom">
                                                <h6 class="m-0 themeBlue fw-bold">
                                                    <span class="" style={{ color: 'rgb(61, 160, 170)' }}>
                                                        ■</span>{" "}
                                                    Target Date
                                                </h6>
                                                <div className='d-flex pt-2 align-items-center'>
                                                    {/* <img src={Images.calender_grey_img} alt="calender_grey_img" /> */}
                                                    <p class="m-0 themeBlue ms-1">
                                                        {convertToMomentDate(task_datetime)}
                                                    </p>
                                                </div>
                                            </div>
                                            {/* <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                        <h6 class="m-0 themeBlue fw-bold">
                          <span class="" style={{ color: 'rgb(61, 160, 170)' }}>
                            ■</span>{" "}
                          End Date
                        </h6>
                        <div className='d-flex pt-2 align-items-center'>
                          <img src={Images.calender_grey_img} alt="calender_grey_img" />
                          <p class="m-0 themeBlue ms-1">
                            {convertToMomentDate(task?.ends_on_data?.endDate)}
                          </p>
                        </div>
                      </div> */}
                                        </Col>
                                        <Col lg="4" className='my-2 rounded py-3  h-100' style={{ border: "1px solid #41A2A8", backgroundColor: "#97BC740A" }}>
                                            <div className="py-2 mt-1 h-100 rounded d-flex flex-column align-items-center justify-content-center">
                                                {/* <img src={Images.calender_img} alt="calender_img" /> */}
                                                <h4 style={{ fontSize: "16px" }} className='pt-3'>Task Schedule</h4>
                                                {/* <h5 className='' style={{ fontWeight: "bold" }}>Twice / Week</h5> */}
                                                <h5 className='' style={{ fontWeight: "bold", fontSize: "14px" }}>
                                                    {task?.duration === 'no_repeat' ? 'No Repeat' : `${task?.custom_duration?.every} / ${task?.custom_duration?.durationType}`}
                                                </h5>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg="6" sm="12" className="my-3">
                                    {/* <h6 className="m-0 themeBlue fw-sbold">Notes</h6> */}
                                    <NotesComponent
                                        // allRecordsHeading={"All Intructions"}
                                        disablePin={true}
                                        disableAdd={true}
                                        disableEdit={true}
                                        // showAllMessage={"Show All"}
                                        // heading="Clinician's Instructions"
                                        // buttonName="Create"
                                        notes={noteDetails}
                                        className={`form-control`}
                                        // module={`task_occurence_${moment(task_datetime).format("YYYY-MM-DD")}`}
                                        module={`task_occurence`}
                                        client_id={groupId}
                                    />
                                </Col>
                                <Col md="12" sm="6" className='my-2'>
                                    <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                        <h6 className="m-0 themeBlue fw-bold">
                                            <span style={{ color: 'rgb(61, 160, 170)' }}>■</span>{" "}
                                            Description
                                        </h6>
                                        <p className="m-0 themeBlue pt-2">
                                            {task?.description || "--"}
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </section >

                    <section className='mt-4'>
                        <Container fluid>
                            <Row>
                                <Col lg="12">
                                    <div className='px-2 py-3 rounded' style={{ backgroundColor: "#B46C9F1F" }}>
                                        <p className='mb-0' style={{ color: "#071E3E" }}><span className='px-2 py-2 rounded me-3' style={{ backgroundColor: "#B46C9F33", color: "#82777f", fontWeight: "700" }}>Cinician's instructions</span>
                                            {task?.clinical_instruction || "--"}
                                        </p>
                                    </div>
                                </Col>
                                <Col lg="6" className="my-2">
                                    <ViewAttachments
                                        attachments={task?.documents}
                                        handleViewPdf={handleViewPdf}
                                        title={"Documents :"}
                                    />
                                </Col>
                                <Col lg="6" className="my-2">
                                    <ViewAttachments
                                        attachments={task?.resources}
                                        handleViewPdf={handleViewPdf}
                                        title={"Resources :"}
                                    />
                                </Col>
                            </Row>
                        </Container>
                    </section>

                    <section className='my-4'>
                        <Formik
                            innerRef={formikRef}
                            initialValues={initialValues}
                            // validationSchema={validationSchema}
                            onSubmit={handleSubmit}
                            enableReinitialize
                        >
                            {({
                                values,
                                errors,
                                setFieldValue,
                                handleSubmit
                            }) => {
                                return (
                                    <Form onSubmit={handleSubmit}>
                                        <Container fluid>
                                            {
                                                data?.AllTaskData?.map((item, index) => <div className="mt-5 border-bottom py-3">
                                                    <Row>
                                                        <Col md="6" sm="6" className='my-2'>
                                                            <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                                                <h6 class="m-0 themeBlue fw-bold">
                                                                    <span class="" style={{ color: 'rgb(61, 160, 170)' }}>
                                                                        ■</span>{" "}
                                                                    Last Name
                                                                </h6>
                                                                <p class="m-0 themeBlue pt-2">
                                                                    {item?.associatedClient?.lastname}
                                                                </p>
                                                            </div>
                                                        </Col>
                                                        <Col md="6" sm="6" className='my-2'>
                                                            <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                                                <h6 class="m-0 themeBlue fw-bold">
                                                                    <span class="" style={{ color: 'rgb(61, 160, 170)' }}>
                                                                        ■</span>{" "}
                                                                    First Name
                                                                </h6>
                                                                <p class="m-0 themeBlue pt-2">
                                                                    {item?.associatedClient?.firstname}
                                                                </p>
                                                            </div>
                                                        </Col>
                                                        <Col lg="6">
                                                            {trackerType !== "none" && (
                                                                <label className="fw-semibold my-3">Tracker</label>
                                                            )}
                                                            {trackerType === "discrete" ? (
                                                                <GoalTrackingForm index={index} disabled={previewMode} />
                                                            ) : trackerType === "frequency" ? (
                                                                <div className="d-flex align-items-start flex-column justify-content-between gap-10 w-100">
                                                                    <TrackerRangeSlider
                                                                        value={values?.clientData[index]?.tracker?.percentage || 0}
                                                                    >
                                                                        <AppInputField
                                                                            id={`frequency-range`}
                                                                            className={`frequency-range`}
                                                                            name={`clientData[${index}].tracker.percentage`}
                                                                            type={"range"}
                                                                            min="0"
                                                                            max="100"
                                                                            disabled={previewMode}
                                                                        />
                                                                    </TrackerRangeSlider>
                                                                </div>
                                                            ) : (
                                                                null
                                                            )}
                                                            <div className="py-2">
                                                                {previewMode && <label className="fw-semibold my-3">Description</label>}
                                                                <div className="position-relative">
                                                                    <AppInputField
                                                                        name={`clientData[${index}].answer`}
                                                                        fieldType={"textarea"}
                                                                        className="form-control rounded-3 bg-white h-auto"
                                                                        rows={5}
                                                                        placeholder="Add information on what types of activities were used to elicit the goal"
                                                                        disabled={previewMode}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        {
                                                            trackerType != "discrete" &&
                                                            <Col lg="6" className="my-2">
                                                                <div className="cardCstm p-3 bg-white shadow rounded my-2">
                                                                    <h6 class="m-0 themeBlue fw-bold">
                                                                        <span class="" style={{ color: 'rgb(61, 160, 170)' }}>
                                                                            ■</span>{" "}
                                                                        Attendance
                                                                    </h6>
                                                                    <div className="mt-2 d-flex align-items-center">
                                                                        <span>Absent</span>
                                                                        <Switch
                                                                            className="mx-2"
                                                                            uncheckedIcon={""}
                                                                            checkedIcon={""}
                                                                            onHandleColor={"#A3DF00"}
                                                                            offHandleColor={"#A3DF00"}
                                                                            onColor={"#E6E6E6"}
                                                                            offColor={"#E6E6E6"}
                                                                            height={18}
                                                                            width={40}
                                                                            checked={values?.clientData[index]?.attendance != "absent"}
                                                                            onChange={(checked) => {
                                                                                setFieldValue(
                                                                                    `clientData[${index}].attendance`,
                                                                                    checked ? "present" : "absent"
                                                                                );
                                                                            }} disabled={previewMode}
                                                                        />
                                                                        <span>Present</span>
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        }
                                                        {trackerType === "discrete" && (
                                                            <Col lg="6" className="my-2">
                                                                <div className="cardCstm p-3 bg-white shadow rounded my-2">
                                                                    <h6 class="m-0 themeBlue fw-bold">
                                                                        <span class="" style={{ color: 'rgb(61, 160, 170)' }}>
                                                                            ■</span>{" "}
                                                                        Attendance
                                                                    </h6>
                                                                    <div className="mt-2 d-flex align-items-center">
                                                                        <span>Absent</span>
                                                                        <Switch
                                                                            className="mx-2"
                                                                            uncheckedIcon={""}
                                                                            checkedIcon={""}
                                                                            onHandleColor={"#A3DF00"}
                                                                            offHandleColor={"#A3DF00"}
                                                                            onColor={"#E6E6E6"}
                                                                            offColor={"#E6E6E6"}
                                                                            height={18}
                                                                            width={40}
                                                                            checked={values?.clientData[index]?.attendance != "absent"}
                                                                            onChange={(checked) => {
                                                                                setFieldValue(
                                                                                    `clientData[${index}].attendance`,
                                                                                    checked ? "present" : "absent"
                                                                                );
                                                                            }} disabled={previewMode}
                                                                        />
                                                                        <span>Present</span>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className="cardCstm rounded-3"
                                                                    style={{ background: "#F7F0F5" }}
                                                                >
                                                                    <div className="top p-3 border-bottom">
                                                                        <h6
                                                                            style={{ fontSize: 14 }}
                                                                            className="m-0 fw-bold text-uppercase"
                                                                        >
                                                                            Session Outcomes
                                                                        </h6>
                                                                    </div>
                                                                    <div className="contentBody p-3">
                                                                        <Row>
                                                                            <Col lg="5" className="my-2">
                                                                                <SessionOutcomePieChart
                                                                                    trackingData={
                                                                                        values?.clientData[index]?.goalTracking
                                                                                    }
                                                                                />
                                                                            </Col>
                                                                            <Col lg="7" className="my-2">
                                                                                {values?.clientData[index]?.goalTracking?.length > 0 ? (
                                                                                    <ul className="list-unstyled ps-0 mb-0">
                                                                                        {Object.entries(GOAL_TRACK_PARAMETERS_STAFF)?.map(([param, label], i) => {
                                                                                            let parameterPercentage = getGoalTrackingPercentage(param, values?.clientData[index]?.goalTracking);
                                                                                            return (
                                                                                                <li
                                                                                                    key={i}
                                                                                                    className="py-1 d-flex align-items-center justify-content-between gap-10"
                                                                                                >
                                                                                                    <p className="m-0">
                                                                                                        <span className="fw-sbold">
                                                                                                            {param}
                                                                                                        </span>{" "}
                                                                                                        -{label}
                                                                                                    </p>
                                                                                                    <p className="m-0 fw-bold">
                                                                                                        <span className="px-2">
                                                                                                            {
                                                                                                                parameterPercentage
                                                                                                            }
                                                                                                        </span>
                                                                                                        %
                                                                                                    </p>
                                                                                                </li>
                                                                                            );
                                                                                        }
                                                                                        )}
                                                                                    </ul>
                                                                                ) : (
                                                                                    <p>
                                                                                        Goal not tracked yet
                                                                                    </p>
                                                                                )}
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        )}
                                                    </Row>
                                                    <Row>
                                                        {console.log('values?.clientData[index]?.files', values?.clientData[index]?.files)}
                                                        <Col lg="6">
                                                            <div className="py-2">
                                                                <div className="position-relative">
                                                                    <ul className="list-unstyled">
                                                                        <ViewAttachments
                                                                            attachments={values?.clientData[index]?.files || []}
                                                                            handleViewPdf={handleViewPdf}
                                                                            title={"Attachments:"}
                                                                        />
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    {/* <div className='mt-5' style={{ display: "inline-block" }}>
                                                        {/* <button type="button" onClick={handleuload} className='py-3 px-5 m-0 border-0 text-white rounded' style={{ background: "#3DA0AA" }}>
                          <img className='me-1' src={Images.attach_file_add} alt="attach_file_add" />
                          Attach Document
                        </button> */}

                                                    {/* <AppFileUploadNestedField
                                                            name={`clientData[${index}].files`}
                                                            acl={"private"}
                                                            accept="image/*, application/pdf, .doc, .docx"
                                                            allowedTypes={[MIME_TYPES.pdf, MIME_TYPES.png, MIME_TYPES.jpeg, MIME_TYPES.jpg, MIME_TYPES.webp, MIME_TYPES.doc, MIME_TYPES.docx]}
                                                            className={`form-control`}
                                                            onChange={(name, value) => {
                                                                // Update the specific client's files array
                                                                const clientData = [...values.clientData];
                                                                clientData[index].files = value;
                                                                setFieldValue('clientData', clientData);
                                                            }}
                                                        />
                                                    </div> */}
                                                </div>)
                                            }

                                            {/* <div className='mt-5 d-flex gap-10' >
                        <LoadingButton
                          className='border-0 commonBtn'
                          style={{ background: "#3DA0AA" }}
                          onClick={handleSaveProgress}
                          isLoading={saveProgressLoading}
                          disabled={previewMode}
                        >
                          Save For Later
                        </LoadingButton>
                        <LoadingButton
                          className='commonBtn'
                          // style={{ background: "#3DA0AA" }}
                          type="submit"
                          isLoading={submitTaskLoading}
                          disabled={previewMode}
                        >
                          Submit
                        </LoadingButton>
                      </div> */}
                                        </Container>
                                    </Form>
                                )
                            }}
                        </Formik>
                    </section>
                </section>
            )}

        </>
    )
}

export default GroupTaskSession